import logo from './logo.svg';
import React from 'react';
import './App.css';
import Navbar from './Navbar'; // Import the Navbar component
import { BrowserRouter, Route, Routes, Link } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Tools from './pages/Tools';
import TimezoneConverter from './pages/TimezoneConverter';
import LengthConverter from './pages/LengthConverter';
import JsonFormatTool from './pages/JsonFormatTool';
import NewsDetail from './pages/NewsDetail';
import AdminPage from './pages/AdminPage';
import Login from './pages/Login';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />  {/* Include the Navbar here */}
          <div className="main-content">
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<Home />} />
              <Route path="/tools" element={<Tools />} />
              <Route path="/news/:id" element={<NewsDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/timezone_converter" element={<TimezoneConverter />} />
              <Route path="/length_converter" element={<LengthConverter />} />
              <Route path="/json_format" element={<JsonFormatTool />} />

              {/* Protected routes */}
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminPage />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </div>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
